<template>
  <div class="content">
    <div class="loader-backdrop" v-if="loadingCheck"></div>
    <div class="loader" v-if="loadingCheck">
      <loader/>
    </div>
    <div class="register-content">
      <div class="container">
        <div class="page">
          <div class="grid grid-1">
            <form action="" method="get" id="app" @submit="handleSubmit">
              <div class="c-card">
                <div class="c-card--title">
                  <h3>{{ $t('register.info.subTitle') }}</h3>
                </div>
                <div class="content-title">{{ $t('register.info.obligatory') }}</div>
                <div class="c-card--content">
                  <div class="gender-selection fields">
                    <div class="error input-error" v-if="genderError && genderError.length > 0">{{ genderError }}</div>
                    <select name="gender" class="gender fields" v-model="gender"
                            @change="resetField('genderError')" :class="{errored: hasGenderError}">
                      <option value="Selection" disabled>{{ $t('register.info.gender.selection') }}</option>
                      <option value="M">{{ $t('register.info.gender.M') }}</option>
                      <option value="F">{{ $t('register.info.gender.F') }}</option>
                    </select>
                  </div>

                  <firstname-input v-model="firstName" v-required v-error="firstNameHasError" class="fields"
                                   :placeholder="$t('register.info.firstName')" ref="inputFirstName" icon="person"
                                   :clean-errors-on-input="true"/>

                  <lastname-input v-model="lastName" v-required v-error="lastNameHasError" class="fields"
                                  :clean-errors-on-input="true"
                                  :placeholder="$t('register.info.lastName')" ref="inputLastName" icon="person"/>

                  <birthdate-input v-model="birthDate" v-required v-error="birthDateHasError" ref="inputBirthDate"
                                   :placeholder="$t('register.info.birthDate')" class="fields"
                                   :clean-errors-on-input="true"
                  />

                  <email-input v-model="email" v-required v-error="emailHasError" class="fields"
                               :placeholder="$t('register.info.email')" autocomplete="none"
                               ref="inputEmail" :clean-errors-on-input="true" :use-mail-checker="true"/>


                  <password-input v-model="password" v-required v-error="passwordHasError" class="fields"
                                  :placeholder="$t('register.info.password')" ref="inputPassword"
                                  icon="code" :use-password-checker="true" :use-password-strength-display="true"
                                  :clean-errors-on-input="true" :use-dynamic-errors="true"/>

                  <password-input v-model="passwordConf" v-required v-error="passwordConfHasError" class="fields"
                                  :placeholder="$t('register.info.passwordConf')" :clean-errors-on-input="true"
                                  ref="inputPasswordConf" icon="code" :should-equal="password"
                  />

                  <div class="phone-number">
                    <div class="error input-error" v-if="hasPhoneError && phoneError.length> 0" ref="phoneInput">
                      {{ phoneError }}
                    </div>
                    <vue-phone-number-input :translations="phoneLocale" :value="defaultPhone" @update="phoneUpdate"
                                            class="fields pa-0"
                                            ref="phoneInput" @change="resetField('phoneError')"/>
                  </div>
                </div>

              </div>

              <div class="c-card">
                <div class="address-content c-card--title">
                  <h3>{{ $t('register.info.subTitle2') }}</h3>
                </div>
                <div class="content-title">{{ $t('register.info.compSubTitle2') }}</div>
                <div class="c-card--content">

                  <text-input v-model="address" v-required v-error="addressHasError" ref="inputAddress" class="fields"
                              :placeholder="$t('register.info.address')" :clean-errors-on-input="true"/>

                  <text-input v-model="addressComplement" v-error="addressComplementHasError"
                              :placeholder="$t('register.info.addressComplement')" ref="inputAddressComplement"
                              :clean-errors-on-input="true" class="fields"/>

                  <text-input v-model="zipCode" v-required v-error="zipCodeHasError" ref="inputZipCode" class="fields"
                              :placeholder="$t('register.info.zipCode')" :clean-errors-on-input="true"/>

                  <text-input v-model="city" v-required v-error="cityHasError" ref="inputCity" class="fields"
                              :placeholder="$t('register.info.city')" :clean-errors-on-input="true"/>

                  <div class="fields country">
                    <div class="error input-error" v-if="country_idError && country_idError.length > 0">
                      {{ country_idError }}
                    </div>
                    <v-select
                        :options="countries.map(c => ({id: c.id, text: c.name}))"
                        :settings="{placeholder: $t('register.info.country') + ' *'}"
                        v-model="country_id" class="fields"
                        v-on:change="resetField('country_idError')"
                        ref="inputCountry"
                    />
                  </div>

                  <checkbox-input class="checkbox checkbox fields" name="promoEmail"
                                  :label="$t('register.info.promoEmail')"
                                  v-model="promoEmail"/>

                  <div class="fields checkbox">
                    <div class="error-checkbox error" v-if="conditionsError && conditionsError.length > 0">
                      {{ conditionsError }}
                    </div>
                    <checkbox-input class="checkbox fields" name="conditions" @input="resetField('conditionsError')"
                                    :label="`${$t('register.info.iAccept')} <a class='orange' href='javascript:openModal(0)'>${$t('register.info.terms')}</a> ${$t('register.info.and')}
                                    <a class='orange' href='javascript:routeRGPD()'> ${$t('register.info.confidentiality')}</a>`"
                                    v-model="conditions"/>
                  </div>
                </div>
                <div class="c-card--footer">
                  <button type="submit" class="colored-btn red-btn" :disabled="hasError" @click="send">
                    <span>{{ $t('register.info.btn') }}</span>
                  </button>
                </div>
              </div>
            </form>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapState} from 'vuex';
import TextInput from '../../components/text-input';
import EmailInput from '../../components/email-input';
import PasswordInput from '../../components/password-input';
import DateInput from '../../components/date-input';
import Loader from '../../components/loader.component';
import CheckboxInput from '../../components/checkbox-input';
import BirthdateInput from '../../components/birthdate-input';
import {withComputeError} from '../../components/mixins/input-wrapper.mixin';
import FirstnameInput from '../../components/firstname-input';
import LastnameInput from '../../components/lastname-input';
import moment from 'moment';
import {F_ERR_ENUM} from '../../enum/field-error.enum';

export default {
  mixins: [withComputeError],
  name: 'register',
  components: {
    LastnameInput,
    FirstnameInput,
    BirthdateInput,
    PasswordInput,
    EmailInput,
    TextInput,
    DateInput,
    Loader,
    CheckboxInput
  },
  computed: {
    hasError() {
      return this.hasGenderError || this.firstNameHasError || this.lastNameHasError || this.birthDateHasError
          || this.emailHasError || this.passwordHasError || this.passwordConfHasError || this.hasPhoneError
          || this.addressHasError || this.addressComplementHasError || this.zipCodeHasError || this.cityHasError
          || this.hasCountry_idError || this.hasConditionsError || this.registerOnce;
    },
    loadingCheck() {
      return !!(this.loading || this.registerLoading || this.clientLoading);
    },
    ...mapState({
      loading: s => s.countries.loading,
      countries: s => s.countries.countries,
      lang: s => s.lang.currentLang,
      client: s => s.client.connect,
      apiEmailError: s => s.registration.errors.email,
      apiPhoneError: s => s.registration.errors.phone,
      apiPasswordError: s => s.registration.errors.password,
      apiCountryError: s => s.registration.errors.country,
      apiCountryAddressError: s => s.registration.errors['address.country'],
      apiAuth_registerError: s => s.registration.errors.Auth_register,
      registerLoading: s => s.registration.loading,
      clientLoading: s => s.client.loading,
    })
  },

  data() {
    return {
      gender: 'Selection',
      genderError: '',
      hasGenderError: false,
      firstName: '',
      firstNameHasError: false,
      lastName: '',
      lastNameHasError: false,
      birthDate: '',
      birthDateHasError: false,
      email: '',
      emailHasError: false,
      password: '',
      passwordHasError: false,
      passwordConf: '',
      passwordConfHasError: false,
      phone: '',
      phoneError: '',
      hasPhoneError: false,
      defaultPhone: '',
      address: '',
      addressHasError: false,
      addressComplement: '',
      addressComplementHasError: false,
      zipCode: '',
      zipCodeHasError: false,
      city: '',
      cityHasError: false,
      country_id: null,
      country_idError: '',
      hasCountry_idError: false,
      conditions: null,
      conditionsError: '',
      hasConditionsError: true,
      promoEmail: null,
      pub: false,
      registerOnce: false,
      hasAuth_registerError: false,
      phoneLocale: {
        countrySelectorLabel: this.$t('profile.info.phone.countrySelectorLabel'),
        countrySelectorError: this.$t('profile.info.phone.countrySelectorError'),
        phoneNumberLabel: this.$t('profile.info.phone.phoneNumberLabel'),
        example: this.$t('profile.info.phone.example'),
      },
      apiRef: [
        'inputEmail',
        'inputPassword',
        'inputPhone',
        'inputCountry',
      ]
    };
  },

  watch: {
    country_id() {
      if (this.country_id) {
        this.country_idError = '';
      }
    },
    promoEmail() {
      if (this.promoEmail === true) {
        this.pub = true;
        return;
      }
      this.pub = false;
    },
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    },
    async send(e) {
      this.formCheck(e);
      this.computeErrors();
      this.cleanErrorApi();
      e.preventDefault();

      if (this.hasError === false) {
        this.registerOnce = true;
        await this.$store.dispatch('registration/register', {
          registeredFrom: 'DIRECT_SITE',
          lang: this.lang,
          title: this.gender,
          firstName: this.firstName.trim(),
          lastName: this.lastName.trim(),
          phone: this.phone,
          email: this.email.trim(),
          password: this.password,
          dobTimestamp: moment.utc(this.birthDate, 'DD/MM/YYYY').format('X'),
          country: this.country_id,
          pub: this.pub,
          address: {
            address: this.address,
            additional: this.addressComplement,
            zip: this.zipCode,
            city: this.city,
            country: this.country_id,
            description: this.address,
          },
          stayReason: "NULL",
        });
        this.registerOnce = false;
        if (this.apiEmailError) {
          this.$refs.inputEmail.setError(F_ERR_ENUM.API, (this.apiEmailError || {alreadyInUse: false}).alreadyInUse ? 'already_in_use' : null);
        }
        if (this.apiPasswordError) {
          this.$refs.inputPassword.setError(F_ERR_ENUM.API, (this.apiPasswordError || {notStrongEnough: false}).notStrongEnough ? 'not_strong_enough' : null);
        }
        if (this.apiPhoneError) {
          this.hasPhoneError = true;
          this.phoneError = this.$t('already_in_use');
        }
        if (this.apiCountryError) {
          this.hasCountry_idError = true;
          this.country_idError = this.$t('doesnt_exist');
        }
        if (this.apiCountryAddressError) {
          this.hasCountry_idError = true;
          this.country_idError = this.$t('doesnt_exist');
        }
        if (this.apiAuth_registerError) {
          this.hasAuth_registerError = true;
        }

        if (!this.apiEmailError && !this.apiPasswordError && !this.apiPhoneError && !this.apiCountryError && !this.apiCountryAddressError && !this.apiAuth_registerError) {
          await this.$store.dispatch('client/connect', {
            email: this.email,
            password: this.password,
            rememberMe: true
          });
          await this.$router.push({name: 'home'});
        }
      } else {
        window.scrollTo(0, 0)
      }
    },
    resetField(fileName) {
      if (Object.keys(this)
          .indexOf(fileName) === -1) {
        return;
      }
      this[fileName] = '';
      this['has' + fileName.charAt(0).toUpperCase() + fileName.slice(1)] = false;
    },

    phoneUpdate(v) {
      this.defaultPhone = v.formatNational || v.phoneNumber;
      if (v.isValid) {
        this.phone = v.e164;
        this.hasPhoneError = false;
      } else {
        this.hasPhoneError = true;
        this.phone = '';
      }
    },

    cleanErrorApi() {
      for (const key of this.apiRef) {
        if (!this.$refs[key] || !(typeof this.$refs[key].setError === 'function')) {
          continue;
        }
        this.$refs[key].setError(F_ERR_ENUM.API, null);
      }
    },

    formCheck(e) {
      if (this.gender !== 'Selection' && this.conditions && this.country_id && this.phone) {
        return true;
      }
      if (this.gender === 'Selection') {
        this.hasGenderError = true;
        this.genderError = this.$t('field_is_required');
      }
      if (this.country_id === null) {
        this.hasCountry_idError = true;
        this.country_idError = this.$t('field_is_required');
      }
      if (this.conditions === false) {
        this.hasConditionsError = true;
        this.conditionsError = this.$t('register.info.conditionsError');
      }
      if (this.phone === '') {
        this.hasPhoneError = true;
        this.phoneError = this.$t('field_is_required');
      }
      e.preventDefault();
    }
  },
  async mounted() {
    await this.$store.dispatch('countries/init');
  },
};
</script>

<style scoped>
.content {
  margin: 210px auto auto auto;
}

.country-selector.has-hint .country-selector__input[data-v-035dc6a2], .country-selector.has-value .country-selector__input[data-v-035dc6a2] {
  padding-right: 2px !important;
}

.loader {
  position: fixed;
  background: white;
  width: 400px;
  left: calc(50% - 200px);
  top: calc(50vh - 60px);
  box-shadow: 0 0 20px 4px rgba(0,0,0,0.1);
  height: 120px;
  z-index: 2;
}
.loader-backdrop {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.1);
}
</style>



// WEBPACK FOOTER //
// src/pages/client/register.vue